module.exports = __webpack_public_path__ + "img/feature_buy_zh.0319f7cd.png";